import * as React from 'react';
import * as styles from './styles.scss';
import { observer } from 'mobx-react-lite';
import type { FileLinkThumbnailViewProps } from 'owa-timestream-asset-sdk-filepicker';
import { Image, ImageFit, ImageLoadState } from '@fluentui/react/lib/Image';

export default observer(function ImageSource(props: FileLinkThumbnailViewProps) {
    const [loadState, setLoadState] = React.useState<ImageLoadState>(ImageLoadState.notLoaded);

    const shouldShowThumbnail = !!props.thumbnailUrl && loadState !== ImageLoadState.error;

    return shouldShowThumbnail ? (
        <div className={styles.imgContainer}>
            <Image
                src={props.thumbnailUrl}
                imageFit={ImageFit.contain}
                width={'100%'}
                height={'100%'}
                draggable={false}
                onLoadingStateChange={setLoadState}
                {...props}
            />
        </div>
    ) : null;
});
